// extracted by mini-css-extract-plugin
module.exports = {"review-coupon-dialog":"review-coupon-dialog-aa4bd772862adc28badd70d6a9ab11ae","el-dialog__body":"el-dialog__body-ad828de157bb6c9e19a9025be36ac235"};